/* unplugin-vue-components disabled */import { render } from "./landFront.vue?vue&type=template&id=e4ed2598&scoped=true"
import script from "./landFront.vue?vue&type=script&lang=js"
export * from "./landFront.vue?vue&type=script&lang=js"

import "./landFront.vue?vue&type=style&index=0&id=e4ed2598&scoped=true&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ed2598"]])

export default __exports__